import { segmentTrack } from "./segment-track";

export const trialSignupCompleted = (
  fields?: (string | undefined | null)[],
  step?: number,
  promoCode?: string
) => {
  segmentTrack("Trial Sign Up Step Completed", {
    fields,
    step: `step ${step} completed`,
    initiator: "User",
    object: "Trial Sign Up Step",
    action: "Completed",
    source_application: "Marketing",
    ...(promoCode && { promo_code: promoCode }),
  });
};
